var structure = {};

structure["/"] = {
  showButtons: false
};

structure["/login"] = {
  showButtons: false
};

structure["/consent"] = {
  showNext: true,
};

structure["/avatar"] = {
  showButtons: false
};

structure["/langset"] = {
  showButtons: false
};

structure["/about"] = {
  showNext: true,
  menu: true,
  menuSection: "overview",
  id: 'page.about',
};

structure["/overallstudyresults"] = {
  showButtons: true,
  FAQ: true,
  menu: true,
  menuSection: "overview",
  id: 'page.overallstudyresults',
};

structure["/health"] = {
  showButtons: true,
  FAQ: true,
  menu: true,
  menuSection: "overview",
  id: 'page.healthandchemicals'
}

structure["/readinggraphs"] = {
  showButtons: true,
  FAQ: true,
  menu: true,
  menuSection: "personal_results",
  id: 'page.graphreading'
}

structure["/summary"] = {
  showNext: true,
  showPrevious: true,
  FAQ: true,
  menu: true,
  menuSection: "personal_results",
  id: 'app.pages.summary',
};

structure["/chemicals/bisphenols"] = {
  group: 'bisphenols',
  showNext: true,
  FAQ: true,
  menu: true,
  menuSection: "personal_results",
  id: 'chemicals.bisphenols',
  summary: true,
};

structure["/chemicals/antimicrobials"] = {
  group: 'antimicrobials',
  showNext: true,
  FAQ: true,
  menu: true,
  menuSection: "personal_results",
  id: 'chemicals.antimicrobials',
  summary: true,
};

structure["/chemicals/chlorinated_phenols"] = {
  group: 'chlorinated_phenols',
  showNext: true,
  FAQ: true,
  menu: true,
  menuSection: "personal_results",
  id: 'chemicals.chlorinated_phenols',
  summary: true,
};

structure["/chemicals/parabens"] = {
  group: 'parabens',
  showNext: true,
  FAQ: true,
  menu: true,
  menuSection: "personal_results",
  id: 'chemicals.parabens',
  summary: true,
};

structure["/chemicals/uv_filters"] = {
  group: 'uv_filters',
  showNext: true,
  FAQ: true,
  menu: true,
  menuSection: "personal_results",
  id: 'chemicals.uv_filters',
  summary: true,
};

structure["/community_action"] = {
  showButtons: true,
  FAQ: true,
  menu: true,
  menuSection: null,
  id: 'page.community_action',
};

// structure["/survey"] = {
//   showButtons: true,
//   FAQ: false,
//   menu: true,
//   menuSection: null,
//   id: 'page.survey',
// };

structure["/conclusion"] = {
  showButtons: true,
  // showPrevious: true,
  FAQ: true,
  menu: true,
  menuSection: null,
  id: 'page.conclusion',
};

structure["/faqpage"] = {
  // showButtons: true,
  showPrevious: true,
  FAQ: false,
  menu: true,
  menuSection: null,
  id: 'common_questions', // for content_en.yaml mapping of title
  // hideinmenu: false
};

structure["/printpage"] = {
  showButtons: false,
  FAQ: false,
  menu: true,
  id: 'page.print_page',  // for content_en.yaml mapping of title
  buttoncolorclass: 'lowpriority',
  hideinmenu: true
};

structure["/appendix"] = {
  showPrevious: true,
  FAQ: false,
  menu: true,
  id: 'page.appendix_page',  // for content_en.yaml mapping of title
  hideinmenu: true
};


export default structure;



// WEBPACK FOOTER //
// ./src/NavigationStructure.js